<template>
  <v-container>
    <static-page-content :uri="`/static/pages/${$route.params.page}`" />
  </v-container>
</template>
<script>
export default {
  name: 'StaticPage'
}
</script>



// WEBPACK FOOTER //
// src/pages/static-page.vue